
import {
    INIT_INTERNAL_CATEGORY_INFO,
    REQUEST_INTERNAL_CATEGORY_START,
    REQUEST_INTERNAL_CATEGORY_SUCCESS,
    REQUEST_INTERNAL_CATEGORY_FAIL,

    POST_INTERNAL_CATEGORY_START,
    POST_INTERNAL_CATEGORY_SUCCESS,
    POST_INTERNAL_CATEGORY_FAIL,

    PATCH_INTERNAL_CATEGORY_SUCCESS,

    DELETE_INTERNAL_CATEGORY_START,
    DELETE_INTERNAL_CATEGORY_SUCCESS,
    DELETE_INTERNAL_CATEGORY_FAIL,

    REQUEST_DETAIL_INTERNAL_CATEGORY_START,
    REQUEST_DETAIL_INTERNAL_CATEGORY_SUCCESS,
    REQUEST_DETAIL_INTERNAL_CATEGORY_FAIL,

    PUT_INTERNAL_CATEGORY_START,
    PUT_INTERNAL_CATEGORY_SUCCESS,
    PUT_INTERNAL_CATEGORY_FAIL,

    DELETE_MULTIPLE_INTERNAL_CATEGORY_START,
    DELETE_MULTIPLE_INTERNAL_CATEGORY_SUCCESS,
    DELETE_MULTIPLE_INTERNAL_CATEGORY_FAIL,

    PATCH_MULTIPLE_INTERNAL_CATEGORY_START,
    PATCH_MULTIPLE_INTERNAL_CATEGORY_SUCCESS,
    PATCH_MULTIPLE_INTERNAL_CATEGORY_FAIL,

    PUT_MULTIPLE_INTERNAL_CATEGORY_START,
    PUT_MULTIPLE_INTERNAL_CATEGORY_SUCCESS,
    PUT_MULTIPLE_INTERNAL_CATEGORY_FAIL,
} from '../actions/internal-category';

export const initialState = { error: null, data: null, isLoading: false }

export const reducer = (state = initialState, action) => {

    const { type, data, payload, error } = action;

    switch (type) {

        case REQUEST_INTERNAL_CATEGORY_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case REQUEST_INTERNAL_CATEGORY_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case REQUEST_INTERNAL_CATEGORY_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        // ----------------------------------------

        case POST_INTERNAL_CATEGORY_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case POST_INTERNAL_CATEGORY_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case POST_INTERNAL_CATEGORY_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        // ----------------------------------------

        case PATCH_INTERNAL_CATEGORY_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        //--------------------------------------

        case DELETE_INTERNAL_CATEGORY_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case DELETE_INTERNAL_CATEGORY_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case DELETE_INTERNAL_CATEGORY_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        //--------------------------------------

        case REQUEST_DETAIL_INTERNAL_CATEGORY_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case REQUEST_DETAIL_INTERNAL_CATEGORY_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case REQUEST_DETAIL_INTERNAL_CATEGORY_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        // ----------------------------------------

        case PUT_INTERNAL_CATEGORY_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case PUT_INTERNAL_CATEGORY_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case PUT_INTERNAL_CATEGORY_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        // ----------------------------------------


        case DELETE_MULTIPLE_INTERNAL_CATEGORY_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case DELETE_MULTIPLE_INTERNAL_CATEGORY_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case DELETE_MULTIPLE_INTERNAL_CATEGORY_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        // ----------------------------------------


        case PATCH_MULTIPLE_INTERNAL_CATEGORY_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case PATCH_MULTIPLE_INTERNAL_CATEGORY_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case PATCH_MULTIPLE_INTERNAL_CATEGORY_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        // ----------------------------------------


        case PUT_MULTIPLE_INTERNAL_CATEGORY_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case PUT_MULTIPLE_INTERNAL_CATEGORY_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case PUT_MULTIPLE_INTERNAL_CATEGORY_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        // ----------------------------------------

        case INIT_INTERNAL_CATEGORY_INFO:
            {
                return initialState;
            }

        default:
            {
                return { ...state };
            }
    }
};

export default reducer;
